import { render } from "./hero-section.vue?vue&type=template&id=381db1a4"
import script from "./hero-section.vue?vue&type=script&lang=js"
export * from "./hero-section.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__